import { useMutation, useQueryClient } from '@tanstack/react-query'

import type { PatchProductBody } from '@snootsvet/shared'

import { useOsApi } from '@/frontend/hooks/api/use-os-api'

export function usePatchProduct() {
  const api = useOsApi()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ id, ...body }: PatchProductBody & { id: string }) => {
      const response = await api.patch('/products/:id', { params: { id }, body })
      if (!response.success) throw new Error(response.error.message)
      return response.data.product
    },
    onSuccess: (product) => {
      queryClient.invalidateQueries({ queryKey: ['products'] })
      queryClient.invalidateQueries({ queryKey: ['product', product.id] })
    },
  })
}
